import Vue from 'vue'
import Router from 'vue-router'

import Main from '@/pages/main'
import About from '@/pages/about'
import Contact from '@/pages/contact'
import ErrorPage from '@/pages/error/errorPage'
import NewsList from '@/pages/news/list'
import NewsDetail from '@/pages/news/detail'
import Team from '@/pages/team'
// import Workflow from '@/pages/workflow'

Vue.use(Router)

// 定义路由
const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      meta: { requiresAuth: false }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: { requiresAuth: false }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: { requiresAuth: false }
    },
    {
      path: '/news',
      name: 'NewsList',
      component: NewsList,
      meta: { requiresAuth: false }
    },
    {
      path: '/news/:id',
      name: 'NewsDetail',
      component: NewsDetail,
      meta: { requiresAuth: false }
    },
    {
      path: '/team',
      name: 'Team',
      component: Team,
      meta: { requiresAuth: false }
    },
    // {
    //   path: '/workflow',
    //   name: 'Workflow',
    //   component: Workflow,
    //   meta: { requiresAuth: false }
    // },
    {
      path: '*',
      component: ErrorPage
    }
  ]
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js